import type { TourStep } from "@/components/GuidedTour";

export const clientDashboardTourSteps: TourStep[] = [
  {
    target: "cd-header",
    title: "Dashboard Overview",
    titleAr: "نظرة عامة على لوحة التحكم",
    description: "Your personal command center. See your account info and use the refresh button to get the latest data.",
    descriptionAr: "مركز التحكم الشخصي. شاهد معلومات حسابك واستخدم زر التحديث للحصول على أحدث البيانات.",
  },
  {
    target: "cd-stats",
    title: "Key Metrics",
    titleAr: "المقاييس الرئيسية",
    description: "Your campaign stats at a glance: total campaigns, active campaigns, total budget, and audience reach.",
    descriptionAr: "إحصائيات حملاتك بنظرة: إجمالي الحملات، الحملات النشطة، الميزانية الإجمالية، ووصول الجمهور.",
  },
  {
    target: "cd-tabs",
    title: "Dashboard Tabs",
    titleAr: "علامات التبويب",
    description: "Switch between Campaigns (view and manage), Analytics (performance data), and Settings (account preferences).",
    descriptionAr: "التبديل بين الحملات (العرض والإدارة)، التحليلات (بيانات الأداء)، والإعدادات (تفضيلات الحساب).",
  },
  {
    target: "cd-listings",
    title: "Your Listings",
    titleAr: "قوائمك",
    description: "See your influencer listings and event organizer profiles that you've registered on the platform.",
    descriptionAr: "شاهد قوائم المؤثرين وملفات منظمي الأحداث التي سجلتها على المنصة.",
  },
  {
    target: "cd-bookings",
    title: "Bookings",
    titleAr: "الحجوزات",
    description: "Track your influencer bookings and event sponsorship requests — see statuses and manage them here.",
    descriptionAr: "تتبع حجوزات المؤثرين وطلبات رعاية الأحداث — شاهد الحالات وأدرها من هنا.",
  },
];
